import styles from './searchSuggestions.module.scss';
import { Chip } from '@/ui-components/atoms/Chip/Chip';

export interface SearchChip {
    text: string;
}
export interface SearchSuggestionsProps {
    title?: string;
    searchChips: SearchChip[];
    onChipSelect?: (text: string) => void;
}

export function SearchSuggestions({ title, searchChips, onChipSelect }: SearchSuggestionsProps): React.JSX.Element {
    return (
        <div className={styles.searchSuggestions}>
            {title && <p className={styles.title}>{title}</p>}
            <ul className={styles.suggestionsRow}>
                {searchChips.map((chip, index) => (
                    <li key={index}>
                        <Chip text={chip.text} onClick={() => onChipSelect?.(chip.text)} />
                    </li>
                ))}
            </ul>
        </div>
    );
}
